var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaadplads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.4,7.93l3.565,0a.193.193,0,0,0,.2-.216C9.063,6.9,8.578,4,6.506,2.363a.205.205,0,0,0-.324.125L5.2,7.694A.2.2,0,0,0,5.4,7.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.666,11.121a.847.847,0,0,1-.639-.292,1.491,1.491,0,0,0-2.143,0,.846.846,0,0,1-1.279,0,1.494,1.494,0,0,0-2.145,0,.846.846,0,0,1-1.28,0,1.5,1.5,0,0,0-2.147,0,.856.856,0,0,1-.642.293.33.33,0,0,0,0,.659,1.5,1.5,0,0,0,1.074-.454.848.848,0,0,1,1.282,0,1.494,1.494,0,0,0,2.146,0,.846.846,0,0,1,1.28,0,1.49,1.49,0,0,0,2.143,0,.845.845,0,0,1,1.278,0,1.486,1.486,0,0,0,1.072.455.33.33,0,0,0,0-.659Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.212,7.054a.317.317,0,0,0-.317.317v.286a.321.321,0,0,0-.411.494c-.011.6-.225.891-.67.958a.439.439,0,0,0-.455-.435H3a.425.425,0,0,0-.4.628l.653.769a1.457,1.457,0,0,1,.853-.257,1.6,1.6,0,0,1,1.146.482.741.741,0,0,0,1.136,0,1.6,1.6,0,0,1,2.29,0,.738.738,0,0,0,1.133,0,1.6,1.6,0,0,1,1.145-.482,1.509,1.509,0,0,1,.291.034l.492-.518c.6-.045.91-.4.946-1.1h.009a.319.319,0,0,0,.2-.075v1.82a.317.317,0,0,0,.634,0V7.371A.317.317,0,0,0,13.212,7.054Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaadplads);
export default __webpack_public_path__ + "static/media/BAADPLADS.4c78a32a230834e563683a485309edc5.svg";
export { ForwardRef as ReactComponent };